import { useTranslation } from "react-i18next"

import { cn } from "@/lib/utils"

const CUSTOMER_TYPE_KEYS = ["person", "individual", "business"] as const

export function getCustomerTypeLabel(customerType: string, t: (key: string) => string) {
  if (CUSTOMER_TYPE_KEYS.includes(customerType as (typeof CUSTOMER_TYPE_KEYS)[number])) {
    return t(`customerProfile.customerType.${customerType}`)
  }

  return customerType
}

type CustomerInfoProps = {
  customerType: string
  name?: string
  email?: string
  phone?: string
  showIcons?: boolean
  className?: string
}

export function CustomerInfo({
  customerType,
  name,
  email,
  phone,
  className,
}: CustomerInfoProps) {
  const { t } = useTranslation()

  return (
    <div className={cn("flex flex-col", className)}>
      <p className="mb-1 text-[14px] leading-[18px] font-medium text-light-muted">
        {getCustomerTypeLabel(customerType, t)}
      </p>
      {name ? (
        <p className="mb-1 sm:mb-4 text-[18px] leading-[24px] font-bold text-foreground">{name}</p>
      ) : null}
      <div className="flex flex-row items-center gap-2">
        {email ? (
          <p className="text-[14px] leading-[18px] font-medium text-light-muted">
            {email}
          </p>
        ) : null}
        {phone ? (
          <>
            <span className="text-[14px] leading-[18px] font-medium text-light-muted">•</span>
            <p className="text-[14px] leading-[18px] font-medium text-light-muted">
              {phone}
            </p>
          </>
        ) : null}
      </div>
      
    </div>
  )
}
